export const EXPORT_MAX_PERIOD_DAYS = 92
export const EXPORT_MAX_ROWS = 100_000
